import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../context-role-element';

export default {
  [CONTEXT.LISTING_PAGE]: {
    [ROLE.CONTAINER]: [
      ELEMENT.ORDER_BY,
      ELEMENT.SEARCH_FILTER_TITLE,
      ELEMENT.SEARCH_FILTER_FIXED_MOBILE,
      ELEMENT.SEARCH_FILTER_VISUAL_FILTERS,
      ELEMENT.SEARCH_FILTER_FACETS,
      ELEMENT.SECTION_SEO_TEXT,
      ELEMENT.SECTION_FAQ,
      ELEMENT.FILTERS,
    ],
    [ROLE.BUTTON]: [ELEMENT.SECTION_FAQ_ITEM, ELEMENT.RANGE_INPUT],
    [ROLE.INPUT]: [ELEMENT.RANGE_INPUT],
    [ROLE.SLIDER]: [ELEMENT.RANGE_INPUT],
  },
} as TValidTestId;
